import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'tpc-individual-travel',
    templateUrl: './individual-travel.component.html',
    styleUrls: ['./individual-travel.component.css']
})
export class IndividualTravelComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/individual-calculator/individual-travel/individual-travel.component.ts